import { DataType, UIFieldType } from '@services/data/productModelTypes';
import { UnsavedChangesSlice } from '@store/types/UnsavedChangesSlice.type';

export function getUnsavedAttributeValue(
  storedAttributes: UnsavedChangesSlice['attributesById'],
  field: {
    id: string;
    attribute?: { id?: string };
    dataType?: any;
    uiFieldType?: any;
  },
  quoteItemId: string,
  attribute: 'value' | 'valueOverride' | 'isUpdatedByUser' = 'value',
) {
  const lookupId = field.attribute?.id ?? `${quoteItemId}-${field.id}`;
  if (attribute === 'isUpdatedByUser') {
    return storedAttributes[lookupId]?.isUpdatedByUser;
  }
  if (field.uiFieldType === UIFieldType.Textbox) {
    // null converts to undefined
    if (storedAttributes[lookupId]?.[attribute] === null) return null;
    if (
      field.dataType === DataType.Float ||
      field.dataType === DataType.Currency ||
      field.dataType === DataType.Integer
    ) {
      return storedAttributes[lookupId]?.[attribute]?.toString().replaceAll(',', '');
    }

    return storedAttributes[lookupId]?.[attribute]?.toString().trim();
  }
  return storedAttributes[lookupId]?.[attribute];
}
